const Header: React.FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>> = (props) => {
    return (
        <header
            {...props}
            className={"px-5 py-10 md:px-32".concat(" " +props.className || "")}
        >
            {props.children}
        </header>
    )
}

export default Header